export default class AdminReports {
    axiosIns = null
    jwtConfig = null
  
    constructor(axiosIns, jwtConfig) {
      this.axiosIns = axiosIns;
      this.jwtConfig = jwtConfig;
    }
  
    fetchPatientSeenGraph(params) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient-seen-graph`, {
        params
      })
    }
    fetchPatientSeen(params) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient-seen`, {
        params
      })
    }

    exportPatientSeen(params) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/export/all`, {
        params,
        responseType: "blob"
      })
    }
  }
